
import React from "react";
import CourseArraySection from "./CourseArraySection";

interface CourseSectionsProps {
  learning_outcomes?: string[] | null;
  target_audience?: string[] | null;
}

const CourseSections = ({ learning_outcomes, target_audience }: CourseSectionsProps) => (
  <div className="grid md:grid-cols-2 gap-10 mb-10">
    <div>
      <h2 className="text-xl font-semibold mb-3">Mida kursusel õpid?</h2>
      <CourseArraySection items={learning_outcomes} />
    </div>
    <div>
      <h2 className="text-xl font-semibold mb-3">
        Kellele see kursus sobib?
      </h2>
      <CourseArraySection items={target_audience} />
    </div>
  </div>
);

export default CourseSections;
